let GLASS_MARKER_ID = 0;

export const GlassPercentageContainerSVG = (
    {
        fillColor = '#4acb5c',
        borderColor = '#048658',
        contrastColor = '#8ab8a8',
        backgroundColor = '#89D894',
        width = 57.41,
        height = 80.21,
        percent = 0

    }
) => {
    const fillPercentage = ((100 - percent) * height) / 100;
    const percentView = Math.round(percent);
    //const fontSize = percent > 99 ? '12' : '15';
    const fontSize = '15';
    const id = `glassMarker${++GLASS_MARKER_ID}`;
    const viewBox = `0 0 ${width} ${height}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Grupo_92"
            data-name="Grupo 92"
            width={50}
            height={60}
            viewBox={viewBox}
        >
            <defs>
                <mask id={id} x="0" y="0" width={width} height={height}>
                    <rect
                        x="0"
                        y="0"
                        width={width}
                        height={fillPercentage}
                        style={{stroke: 'none', fill: '#fff'}}
                    />
                </mask>
            </defs>
            <g
                xmlns="http://www.w3.org/2000/svg"
                id="marker-2"
                data-name="marker"
                transform="translate(0 0)"
            >
                <g id="background" transform="translate(0 0)">
                    <path
                        // eslint-disable-next-line max-len
                        d="M 27.74440765380859 79.32769012451172 C 25.11689186096191 75.6302490234375 11.02597236633301 55.75102996826172 8.177006721496582 50.67843627929688 C 5.519217491149902 46.01403427124023 3.804895401000977 42.46542358398438 2.616940021514893 39.16965866088867 C 1.192462205886841 35.21771240234375 0.5000066161155701 31.48502540588379 0.5000066161155701 27.75830268859863 C 0.5000066161155701 24.0782356262207 1.220639944076538 20.50851440429688 2.641895532608032 17.14830207824707 C 4.014773368835449 13.90245819091797 5.980273246765137 10.98729133605957 8.483795166015625 8.483780860900879 C 10.98731803894043 5.980258464813232 13.90249538421631 4.014769554138184 17.14834022521973 2.641891479492188 C 20.5085620880127 1.220636010169983 24.07829475402832 0.5000026822090149 27.75837326049805 0.5000026822090149 C 31.43845176696777 0.5000026822090149 35.00818252563477 1.220636010169983 38.368408203125 2.641891479492188 C 41.61426162719727 4.014769554138184 44.5294303894043 5.980258464813232 47.03295135498047 8.483780860900879 C 49.53647232055664 10.98729133605957 51.50197219848633 13.90245819091797 52.87486267089844 17.14830207824707 C 54.29611587524414 20.50851440429688 55.01675033569336 24.0782356262207 55.01675033569336 27.75830268859863 C 55.01675033569336 31.96585845947266 54.32773971557617 35.81558227539062 52.91033935546875 39.52744674682617 C 51.56756210327148 43.04388046264648 49.54728317260742 46.57061386108398 46.55238342285156 50.62625885009766 L 46.54122924804688 50.6413688659668 L 46.5312385559082 50.65726852416992 C 42.18861770629883 57.56851577758789 30.10642433166504 75.77255249023438 27.74440765380859 79.32769012451172 Z"
                        stroke="none"
                        fill={backgroundColor}
                    />
                    <path
                        // eslint-disable-next-line max-len
                        d="M 27.74440765380859 79.32769012451172 C 25.11689186096191 75.6302490234375 11.02597236633301 55.75102996826172 8.177006721496582 50.67843627929688 C 5.519217491149902 46.01403427124023 3.804895401000977 42.46542358398438 2.616940021514893 39.16965866088867 C 1.192462205886841 35.21771240234375 0.5000066161155701 31.48502540588379 0.5000066161155701 27.75830268859863 C 0.5000066161155701 24.0782356262207 1.220639944076538 20.50851440429688 2.641895532608032 17.14830207824707 C 4.014773368835449 13.90245819091797 5.980273246765137 10.98729133605957 8.483795166015625 8.483780860900879 C 10.98731803894043 5.980258464813232 13.90249538421631 4.014769554138184 17.14834022521973 2.641891479492188 C 20.5085620880127 1.220636010169983 24.07829475402832 0.5000026822090149 27.75837326049805 0.5000026822090149 C 31.43845176696777 0.5000026822090149 35.00818252563477 1.220636010169983 38.368408203125 2.641891479492188 C 41.61426162719727 4.014769554138184 44.5294303894043 5.980258464813232 47.03295135498047 8.483780860900879 C 49.53647232055664 10.98729133605957 51.50197219848633 13.90245819091797 52.87486267089844 17.14830207824707 C 54.29611587524414 20.50851440429688 55.01675033569336 24.0782356262207 55.01675033569336 27.75830268859863 C 55.01675033569336 31.96585845947266 54.32773971557617 35.81558227539062 52.91033935546875 39.52744674682617 C 51.56756210327148 43.04388046264648 49.54728317260742 46.57061386108398 46.55238342285156 50.62625885009766 L 46.54122924804688 50.6413688659668 L 46.5312385559082 50.65726852416992 C 42.18861770629883 57.56851577758789 30.10642433166504 75.77255249023438 27.74440765380859 79.32769012451172 Z"
                        x="1"
                        y="1"
                        width={width}
                        height={height}
                        stroke="none"
                        fill="#fff"
                        mask={`url(#${id})`}
                    />
                    <path
                        // eslint-disable-next-line max-len
                        d="M 27.75837326049805 1 C 24.14557266235352 1 20.64137268066406 1.707344055175781 17.34311676025391 3.102394104003906 C 14.1568603515625 4.450057983398438 11.29510498046875 6.379570007324219 8.83734130859375 8.837326049804688 C 6.379573822021484 11.29508209228516 4.450061798095703 14.15683746337891 3.102394104003906 17.34307098388672 C 1.707340240478516 20.64132308959961 0.9999961853027344 24.14551544189453 0.9999961853027344 27.75830459594727 C 0.9999961853027344 31.42624664306641 1.682762145996094 35.10346984863281 3.087295532226562 39.00010299682617 C 4.265151977539062 42.26783752441406 5.9683837890625 45.79239273071289 8.609893798828125 50.42820358276367 L 8.611427307128906 50.43089294433594 L 8.612949371337891 50.43359375 C 11.32241058349609 55.25777053833008 24.28362274169922 73.58798980712891 27.73062705993652 78.44474029541016 C 30.82505416870117 73.78480529785156 41.97555160522461 56.96782684326172 46.10788345336914 50.3912467956543 L 46.12786102294922 50.35944747924805 L 46.15017318725586 50.32924652099609 C 49.11740493774414 46.3110466003418 51.11707305908203 42.82202529907227 52.44322967529297 39.34907913208008 C 53.83848571777344 35.6951904296875 54.51673889160156 31.90381240844727 54.51673889160156 27.75830459594727 C 54.51673889160156 24.14551544189453 53.80939483642578 20.64132308959961 52.41435241699219 17.34307098388672 C 51.06667327880859 14.15683746337891 49.13716125488281 11.29508209228516 46.67939758300781 8.837326049804688 C 44.22163009643555 6.379570007324219 41.35988616943359 4.450057983398438 38.17362976074219 3.102394104003906 C 34.87537384033203 1.707344055175781 31.37117385864258 1 27.75837326049805 1 M 27.75837326049805 0 C 43.08889770507812 0 55.51673889160156 12.42781066894531 55.51673889160156 27.75830459594727 C 55.51673889160156 36.46596908569336 52.66597366333008 43.18901443481445 46.95460510253906 50.92327880859375 C 42.09731674194336 58.65361404418945 27.75837326049805 80.2099609375 27.75837326049805 80.2099609375 C 27.75837326049805 80.2099609375 10.91962814331055 56.58272552490234 7.741050720214844 50.92327880859375 C 3.143783569335938 42.85515975952148 -3.814697265625e-06 35.82218170166016 -3.814697265625e-06 27.75830459594727 C -3.814697265625e-06 12.42781066894531 12.42785263061523 0 27.75837326049805 0 Z"
                        stroke="none"
                        fill={borderColor}
                    />
                </g>
            </g>
            <g id="glass-container" transform="translate(13.683 14.243)">
                <path
                    id="Trazado_34"
                    data-name="Trazado 34"
                    d="M22.652,31.872V12.4a12.344,12.344,0,1,1,24.687,0V31.732"
                    transform="translate(-21.148)"
                    fill={fillColor}
                    stroke={borderColor}
                    strokeWidth="1"
                />
                <path
                    id="Trazado_36"
                    data-name="Trazado 36"
                    d="M26.642,479.95H1.055A1.054,1.054,0,0,1,0,478.9v-.024a1.055,1.055,0,0,1,1.055-1.055H26.642a1.055,1.055,0,0,1,1.055,1.055v.024A1.054,1.054,0,0,1,26.642,479.95Zm0,0"
                    transform="translate(0 -446.077)"
                    fill={contrastColor}
                    stroke={borderColor}
                    strokeWidth="1"
                />
                <path
                    id="Trazado_40"
                    data-name="Trazado 40"
                    d="M31.437,44.386a4.022,4.022,0,0,0,3.919-4.118,4.175,4.175,0,0,0-1.715-3.405l-.035-.031a12.415,12.415,0,0,0-4.556,6.72l.111.07A3.775,3.775,0,0,0,31.437,44.386Zm0,0"
                    transform="translate(-27.121 -34.385)"
                    fill={contrastColor}
                    stroke={borderColor}
                    strokeWidth="1"
                />
            </g>
            <g id="Grupo_79" data-name="Grupo 79" transform="translate(27.41 39.979)">
                <g
                    id="Elipse_3"
                    data-name="Elipse 3"
                    fill={backgroundColor}
                    stroke={borderColor}
                    strokeWidth="1"
                >
                    <circle cx="17" cy="17" r="17" stroke="none"/>
                    <circle cx="17" cy="17" r="16.5" fill="none"/>
                </g>
                <text
                    id="_63_"
                    data-name="63%"
                    transform="translate(17.5 23.094)"
                    textAnchor="middle"
                    fill="#000"
                    fontSize={fontSize}
                    fontFamily="sans-serif"
                >
                    <tspan x="0" y="0">
                        {percentView}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};